import React from 'react';
import styles from './TrackShipmentBack.module.scss';
import DataTable from 'react-data-table-component';
import FilterInTable from '../../../../../Manage/FilterInTable';

const data = [
    {
        id: 1,
        shipmentId: 'SHIP-001',
        warehouse: 'Warehouse A',
        shipmentDate: '11/07/2024',
        carrier: 'FedEx',
        trackingNumber: '46457563',
        status: 'In transit',
        action: 'View',
    },
    {
        id: 2,
        shipmentId: 'SHIP-001',
        warehouse: 'Warehouse A',
        shipmentDate: '11/07/2024',
        carrier: 'FedEx',
        trackingNumber: '46457563',
        status: 'In transit',
        action: 'View',
    },
    {
        id: 3,
        shipmentId: 'SHIP-001',
        warehouse: 'Warehouse A',
        shipmentDate: '11/07/2024',
        carrier: 'FedEx',
        trackingNumber: '46457563',
        status: 'Delivered',
        action: 'View',
    },
    {
        id: 4,
        shipmentId: 'SHIP-001',
        warehouse: 'Warehouse A',
        shipmentDate: '11/07/2024',
        carrier: 'FedEx',
        trackingNumber: '46457563',
        status: 'Delivered',
        action: 'View',
    },
    {
        id: 5,
        shipmentId: 'SHIP-001',
        warehouse: 'Warehouse A',
        shipmentDate: '11/07/2024',
        carrier: 'FedEx',
        trackingNumber: '46457563',
        status: 'In transit',
        action: 'View',
    },
];

const columns = [
    {
        name: 'Return Shipment ID',
        selector: (row) => row.shipmentId,
        sortable: true,
        minWidth: "220px",
    },
    {
        name: 'Origin Warehouse',
        selector: (row) => row.warehouse,
        sortable: true,
        minWidth: "200px",
    },
    {
        name: 'Return Date',
        selector: (row) => row.shipmentDate,
        sortable: true,
        minWidth: "160px",
    },
    {
        name: 'Carrier',
        selector: (row) => row.carrier,
        sortable: true,
        minWidth: "120px",
    },
    {
        name: 'Tracking Number',
        selector: (row) => row.trackingNumber,
        sortable: true,
        minWidth: "200px",
    },
    {
        name: 'Status',
        cell: (row) => (
            <span className={getStatusClass(row.status)}>{row.status}</span>
        ),
        sortable: true,
        minWidth: "120px",
    },
    {
        name: 'Action',
        selector: (row) => row.action,
        minWidth: "120px",
    },
];

const getStatusClass = (status) => {
    switch (status.toLowerCase()) {
        case 'in transit':
            return styles.statusInTransit;
        case 'delivered':
            return styles.statusDelivered;
        default:
            return '';
    }
};

const customStyles = {
    headRow: {
        style: {
            backgroundColor: '#FBBD34',
            color: '#FFFFFF',
            fontSize: '16px',
            fontWeight: '600',
            borderBottom: 'none',
        },
    },
    headCells: {
        style: {
            paddingLeft: "20px",
            paddingRight: "20px",
            div: {
                whiteSpace: "normal",
                overflow: "visible",
            },
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '15px 20px',
            div: {
                whiteSpace: "normal !important",
                overflow: "visible !important",
            },
        },
    },
};

const TrackShipmentBack = () => {

    return (
        <div className={styles.mainContainer}>
            <h4 className={styles.sectionHeading}>Track Shipments</h4>

            <div className={styles.filterTableContainer}>

                <FilterInTable componentName={"Track Shipments Back"} />

                <div className={styles.table}>
                    <DataTable
                        columns={columns}
                        data={data}
                        pagination
                        highlightOnHover
                        customStyles={customStyles}
                    />
                </div>
            </div>
        </div>
    )
}

export default TrackShipmentBack;